import React, { useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { getDisplayDate } from 'src/utils/dateUtils';
import { useTranslation } from 'react-i18next';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Datatable from 'src/common/refactoredComponents/dataTable/DataTable';
import {
    HeaderData,
    DemiText,
} from 'src/common/refactoredComponents/dataTable/DataTable.styled';
import UnsavedChanges from 'src/pages/scheduleSurgery/components/surgery/notifications/UnsavedChanges.jsx';
import {
    MainContainerItems,
    Subtitle,
    Div,
} from 'src/pages/orders/components/orderDetails/backOrderDetails/BackOrderDetails.styled';
import { Title } from 'src/pages/orders/components/orderDetails/replenRequest/ReplenRequest.styled';
import {
    AnnouncementContainer,
    HeaderContainer,
    AnnouncementContent,
    MessageData,
    BoxContainer,
    StyledDate,
    Information,
    AnnouncementHeaderContainer,
} from './index.styled';
import { useHistory } from 'react-router-dom';
import { linkTagRegEx } from 'src/constants/regEx';
import {
    getAnnouncements,
    setAnnouncementUnsavedChangesPopUp,
    setSettingsUpdateInProgress,
} from 'src/pages/more/redux/actions';
import { setActiveNavLink } from 'src/pages/home/redux/actions';
import ScrollView from 'src/common/components/scrollview/ScrollView';
import {
    preventBouncingEffect,
    revertBouncingEffect,
    isIpad,
    checkImpersonationActive,
    checkProxyActive,
    navLinkSelectHandler,
    getRoutePathWithParams,
} from 'src/utils/util';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { pageNames } from 'src/constants/appConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const Announcements = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const [cancel] = useState(false);
    const { announcements, loading = false } = useSelector(
        (state) => state.announcementReducer
    );
    const unsavedChangesPopUp = useSelector(
        (state) => state.announcementReducer.unsavedAnnouncementChangesPopUp
    );
    const isDestructiveEnabled = useSelector(
        (state) => state.loginReducer.isDestructiveEnabled
    );

    const routePathForAnnouncementUnsavedChangesPopUp = useSelector(
        (state) =>
            state.announcementReducer
                .routePathForAnnouncementUnsavedChangesPopUp
    );
    let path = routePathForAnnouncementUnsavedChangesPopUp?.path;

    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );

    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );

    useDynatracePageName(pageNames.moreAnnouncements);
    useEffectWithErrorLogging(() => {
        //Added for Dynatrace pageName identification
        localStorage.setItem('pageName', 'Announcements');
        dispatch(
            setActiveNavLink({
                dashboard: false,
                calendar: false,
                admin: false,
                orders: false,
                alerts: false,
                inventory: false,
                more: true,
                deniedUsageOverrides: false,
                productGuide: false,
            })
        );
        dispatch(getAnnouncements());
    }, []);

    const handleContinueOnClick = () => {
        //handleSaveClick(false);
        // dispatch(setSettingsUpdateInProgress(false));
        // if (cancel)
        dispatch(setAnnouncementUnsavedChangesPopUp(false));
        // if (path.includes('http')) {
        //     window.location.href = path;
        // } else {
        //     if (!path || path == '') history.goBack();
        //     else history.push(getRoutePathWithParams(path));
        // }
    };

    const fromSettingsClose = () => {
        //if (cancel)
        dispatch(setAnnouncementUnsavedChangesPopUp(false));
    };

    useEffectWithErrorLogging(() => {
        if (cancel) dispatch(setSettingsUpdateInProgress(true));
        else dispatch(setSettingsUpdateInProgress(false));
    }, [cancel]);

    useEffectWithErrorLogging(() => {
        dispatch(setSettingsUpdateInProgress(true));
    }, []);

    const handleDiscardChanges = () => {
        // setIsCalendarSharing(isCalendarSharingInitialVal);
        //setDefaultView(calendarDefaultViewInitialVal);
        //setCalendarSharingLink(calendarSettings.calendarSharingAddress);
        //setMobileNumber(mobilePhoneNumber?.replace(/[^0-9]/g, ''));
        //setInitialCheckBoxStates();
        //if (cancel)
        dispatch(setAnnouncementUnsavedChangesPopUp(false));
        //dispatch(setSettingsUpdateInProgress(false));
        //setTooglerHandler(true);
        navLinkSelectHandler(
            dispatch,
            setActiveNavLink,
            routePathForAnnouncementUnsavedChangesPopUp.selectOption
        );
        if (path.includes('http')) {
            window.location.href = path;
        } else {
            if (!path || path == '') history.goForward();
            else history.push(getRoutePathWithParams(path));
        }
    };

    // const setAnnouncementCUInProgressLocal = (value) => {
    //     if (!value) {
    //         window.onbeforeunload = null;
    //     }
    //     dispatch(setAnnouncementCUInProgress(value));
    // };

    const isDestructive =
        isDestructiveEnabled ||
        (!checkProxyActive() &&
            !checkImpersonationActive() &&
            (bannerInfo || []).filter(
                (item) => item.messageType === 'userDestructiveMessage'
            ).length > 0);

    useEffectWithErrorLogging(() => {
        if (isDestructive) {
            return;
        }
        preventBouncingEffect();
        return () => {
            revertBouncingEffect();
        };
    }, [isDestructive]);

    if (isDestructive) {
        return null;
    }

    let colData = [
        {
            field: 'startDate',
        },
        {
            field: 'messageText',
        },
    ];

    const displayMessage = (rowDataMessage) => {
        if (linkTagRegEx.test(rowDataMessage)) {
            const splitData = rowDataMessage.split(' ');
            const finalStringArray = splitData.map((item) => {
                if (item.includes('<a')) {
                    item = item.replace(
                        '<a',
                        '<a target="_blank" style="text-decoration:none"'
                    );
                }
                item = item.replaceAll('<pre>', '<p>');
                item = item.replaceAll('</pre>', '</p>');
                item = item.replace('&nbsp;', ' ');
                item = item.replace('&quot;', '"');
                return item;
            });
            rowDataMessage = finalStringArray.join(' ');
        }
        return ReactHtmlParser(rowDataMessage);
    };

    colData = colData?.map((column) => {
        const extraProps = {
            bodyStyle: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
        };
        switch (column.field) {
            case 'startDate':
                extraProps.header = (
                    <HeaderData>
                        <DemiText>{t('announcements.date')}</DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    padding: '0.5rem 1rem 0.5rem 1rem',
                    width: '20%',
                };
                extraProps.bodyStyle = {
                    padding: '0.5rem 1rem',
                    textAlign: 'left',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems width={'100%'}>
                            <Title fontSize={'14px'} color={'#3C3C3C'}>
                                {getDisplayDate(rowData.startDate)}
                            </Title>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'messageText':
                extraProps.header = (
                    <HeaderData>
                        <DemiText>{t('announcements.messages')}</DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    padding: '0.5rem 4rem 0.5rem 0.5rem',
                    width: '80%',
                };
                extraProps.bodyStyle = {
                    padding: '0.5rem 0rem 0.5rem 0.7rem',
                    textAlign: 'left',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems width={'100%'}>
                            <Subtitle fontSize={'14px'} width="100%">
                                <MessageData>
                                    {rowData?.messageText &&
                                        displayMessage(rowData.messageText)}
                                </MessageData>
                            </Subtitle>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });

    return (
        <>
            <AnnouncementContainer>
                <AnnouncementHeaderContainer>
                    <HeaderContainer>
                        {t('announcements.title')}
                    </HeaderContainer>
                </AnnouncementHeaderContainer>
                {loading ? (
                    <Spinner id="more-announcements-announcements-loadingSpinner" animation="border" variant="primary" small />
                ) : (
                    <AnnouncementContent>
                        <ScrollView
                            maxHeight={
                                bannerHeight
                                    ? `calc(85vh - ${bannerHeight})`
                                    : '85vh'
                            }
                        >
                            {announcements?.map((data, index) =>
                                data && data?.messageText && data?.startDate ? (
                                    <React.Fragment
                                        key={`${data.messageCode}_${index}`}
                                    >
                                        <BoxContainer
                                            marginBottom={
                                                announcements.length - 1 ===
                                                    index && '20vh'
                                            }
                                        >
                                            <StyledDate>
                                                {getDisplayDate(data.startDate)}
                                            </StyledDate>
                                            <Information className="more-announcement-information-dt-mask">
                                                {data?.messageText &&
                                                    displayMessage(
                                                        data.messageText
                                                    )}
                                            </Information>
                                        </BoxContainer>
                                    </React.Fragment>
                                ) : null
                            )}
                            <Div>
                                <Datatable
                                    id={'more-announcements-datatable'}
                                    backgroundColorOdd={'#FFFFFF99'}
                                    backgroundColorEven={'#F5F5F599'}
                                    resizableColumns
                                    columns={colData}
                                    data={announcements}
                                    scrollable
                                    scrollHeight={
                                        isIpad()
                                            ? bannerHeight
                                                ? `calc(100vh - 235px - ${bannerHeight})`
                                                : 'calc(100vh - 235px)'
                                            : bannerHeight
                                            ? `calc(100vh - 194px - ${bannerHeight})`
                                            : 'calc(100vh - 194px)'
                                    }
                                    height={'auto'}
                                    rows={15}
                                    emptyMessage={t(
                                        'orders.orderDetails.procedureData.nofound'
                                    )}
                                />
                            </Div>
                        </ScrollView>
                        {unsavedChangesPopUp ? (
                            <UnsavedChanges
                                onDiscard={handleDiscardChanges}
                                onClose={handleContinueOnClick}
                                continueText={t(
                                    'consignmentBilling.common.notifications.continueEditing'
                                )}
                                fromSettingsClose={fromSettingsClose}
                            />
                        ) : null}
                    </AnnouncementContent>
                )}
            </AnnouncementContainer>
        </>
    );
};
export default Announcements;
